import { NgModule } from '@angular/core';
import { KeysPipe } from './keys.pipe';
import { ToArrayPipe } from './to-array.pipe';
import { DefaultsPipe } from './defaults.pipe';
export * from './keys.pipe';
export * from './to-array.pipe';
export * from './defaults.pipe';
var NgObjectPipesModule = (function () {
    function NgObjectPipesModule() {
    }
    return NgObjectPipesModule;
}());
export { NgObjectPipesModule };
NgObjectPipesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    KeysPipe,
                    ToArrayPipe,
                    DefaultsPipe
                ],
                exports: [
                    KeysPipe,
                    ToArrayPipe,
                    DefaultsPipe
                ]
            },] },
];
/** @nocollapse */
NgObjectPipesModule.ctorParameters = function () { return []; };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/object/index.js
// module id = 270
// module chunks = 103